export default __webpack_public_path__ + "static/media/coleta-mujer-castano.283b9644.png";